import { Choices } from "modules/NewClientSurvey/common"
import { List } from "modules/NewClientSurvey/components/Select/List"
import style from "modules/NewClientSurvey/components/Select/style.module.scss"

interface Pros {
    className?: string
    questionId: string
    title?: string
    choices: Choices[]
    onClickItem: (questionId: string, choiceId: string) => void
}

export function Select({ className, questionId, title, choices, onClickItem }: Pros) {
    return (
        <div className={className}>
            {title && <div className={style.title}>{title}</div>}
            <List
                questionId={questionId}
                choices={choices}
                onClickItem={(choiceId) => onClickItem(questionId, choiceId)}
            />
        </div>
    )
}
